import { CommonModule } from '@angular/common';
import { Component, inject, computed } from '@angular/core';
import { NotificationModalService } from '@app/core/services/NotificationModal.service';


@Component({
  selector: 'app-notification-modal',
  standalone: true,
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
  imports: [CommonModule]
})
export class NotificationModalComponent {
  private modalService = inject(NotificationModalService);

  isOpen = this.modalService.isOpen;
  title = computed(() => this.modalService.title());
  isLoading = computed(() => this.modalService.isLoading());
  justOkBtn = computed(() => this.modalService.justOkBtn());
  message = computed(() => this.modalService.message());

  closeModal() {
    if (this.isLoading()) return;
    this.modalService.close();
  }

  confirmAction() {
    this.modalService.accept();
  }
}
